import React, { useState, useEffect } from 'react';
import { FaEdit, FaSave } from 'react-icons/fa';
import { TbCancel } from 'react-icons/tb';
import { employeeService } from '../../services/employeeService';
import { notifyError, notifySuccess } from '../../utils/notifications';

const EmployeeDetails = ({ employeeData, workshopID, onClose }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [originalData, setOriginalData] = useState({});

    useEffect(() => {
        setEditedData(employeeData);
        setOriginalData(employeeData);
    }, [employeeData]);

    const handleEdit = () => {
        setIsEditMode(true);
    };

    const handleCancel = () => {
        setEditedData(originalData);
        setIsEditMode(false);
    };

    const handleSave = async () => {
        try {
            // Separar nombre completo en nombre y apellido
            const nameParts = (editedData.employee_name || '').trim().split(' ');
            const firstName = nameParts[0] || '';
            const lastName = nameParts.slice(1).join(' ') || '';

            const payload = {
                email: editedData.email || '',
                role: editedData.role === 'Admin' ? 'admin' : 'technician',
                details: {
                    name: firstName,
                    last_name: lastName,
                    NSS: editedData.nss || '',
                    phone_number: editedData.phone || '',
                    CURP: editedData.curp || '',
                    address: editedData.address || '',
                    RFC: editedData.rfc || '',
                }
            };

            const employeeId = employeeData?.employee_id;
            await employeeService.updateEmployee(employeeId, payload);
            setOriginalData(editedData);
            setIsEditMode(false);
            notifySuccess('Empleado actualizado correctamente.');
        } catch (error) {
            console.error('Error al actualizar empleado: ', error);
            notifyError('No se pudo actualizar el empleado.');
        }
    };

    return (
        <div className="client-details-content">
            {/* Información del Empleado */}
            <section className="client-info-section">
                <div className="section-header-with-button sticky-section-header">
                    <h3>Información del Empleado</h3>
                    <div className="header-actions">
                        {!isEditMode && (
                            <button className="btn-edit-inline" onClick={handleEdit}>
                                <FaEdit /> Editar
                            </button>
                        )}
                        {isEditMode && (
                            <>
                                <button className="btn-save" onClick={handleSave}>
                                    <FaSave /> Guardar
                                </button>
                                <button className="btn-cancel" onClick={handleCancel}>
                                    <TbCancel /> Cancelar
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <div className="info-grid-editable">
                    <div className="info-field">
                        <label>Nombre Completo:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.employee_name || ''}
                            onChange={(e) => setEditedData({ ...editedData, employee_name: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Rol:</label>
                        <select
                            value={editedData.role || ''}
                            onChange={(e) => setEditedData({ ...editedData, role: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        >
                            <option value="">Seleccionar...</option>
                            <option value="Admin">Administrador</option>
                            <option value="Technician">Técnico</option>
                        </select>
                    </div>
                    <div className="info-field">
                        <label>Correo Electrónico:</label>
                        <input
                            type="email"
                            placeholder="N/A"
                            value={editedData.email || ''}
                            onChange={(e) => setEditedData({ ...editedData, email: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Teléfono:</label>
                        <input
                            type="tel"
                            placeholder="N/A"
                            value={editedData.phone || ''}
                            onChange={(e) => setEditedData({ ...editedData, phone: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>NSS:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.nss || ''}
                            onChange={(e) => setEditedData({ ...editedData, nss: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>CURP:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.curp || ''}
                            onChange={(e) => setEditedData({ ...editedData, curp: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>RFC:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.rfc || ''}
                            onChange={(e) => setEditedData({ ...editedData, rfc: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                    <div className="info-field">
                        <label>Dirección:</label>
                        <input
                            type="text"
                            placeholder="N/A"
                            value={editedData.address || ''}
                            onChange={(e) => setEditedData({ ...editedData, address: e.target.value })}
                            disabled={!isEditMode}
                            className={isEditMode ? 'input-editable' : 'input-readonly'}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EmployeeDetails;
